import i18next from 'i18next';

const FORBIDDEN_SUBCATEGORIES = [
  //DEEPSIGHT RESERVED CATEGORIES
  '6743c5ea-4376-11e9-9c73-0af6991d48ca',
  '708db7dc-4376-11e9-9c74-0af6991d48ca',
];

const NATIONAL_EVENTS_CATEGORY_ID = [
  'fb9febda-4374-11e9-8441-0af6991d48ca',
  '3a5d88cc-4376-11e9-9c72-0af6991d48ca',
];

const sortEvents = (eventsArray) => {
  eventsArray.sort((a, b) => {
    if (FORBIDDEN_SUBCATEGORIES.includes(b.eventSubCategoryId)) {
      if (FORBIDDEN_SUBCATEGORIES.includes(a.eventSubCategoryId)) {
        const aName = a.eventSubCategory.name + a.name;
        const bName = b.eventSubCategory.name + b.name;
        const alphComp = bName.localeCompare(aName);
        if (alphComp === 0) {
          return b.id.localeCompare(a.id);
        }
        return alphComp;
      } else {
        return 1;
      }
    } else if (NATIONAL_EVENTS_CATEGORY_ID.includes(b.eventCategoryId)) {
      if (NATIONAL_EVENTS_CATEGORY_ID.includes(a.eventCategoryId)) {
        const aName = a.eventSubCategory.name + a.name;
        const bName = b.eventSubCategory.name + b.name;
        const alphComp = bName.localeCompare(aName);
        if (alphComp === 0) {
          return b.id.localeCompare(a.id);
        }
        return alphComp;
      } else {
        return 1;
      }
    } else {
      const aName = a.eventSubCategory.name + a.name;
      const bName = b.eventSubCategory.name + b.name;
      const alphComp = bName.localeCompare(aName);
      if (alphComp === 0) {
        return b.id.localeCompare(a.id);
      }
      return alphComp;
    }
  });
  return eventsArray;
};

/**
 * @param {string} weatherType - The weather type to translate. From DATA Team and actually is in french.
 * @returns {string} The translated weather type
 */
const getTranslatedWeatherType = (weatherType) => {
  switch (weatherType) {
    case 'Averses de neige':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_SNOW_FLURRIES');
    case 'Brouillard':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_FOG');
    case 'Ciel dégagé':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_CLEAR_SKY');
    case 'Eclaircies':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_CLEAR_SKIES');
    case 'Faible neige':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_LIGHT_SNOW');
    case 'Forte neige fondue':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_HEAVY_SLEET');
    case 'Légère neige':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_LIGHT_SNOW');
    case 'Légère pluie':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_LIGHT_RAIN');
    case 'Mélange pluie/neige':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_MIXED_RAIN_SNOW');
    case 'Neige':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_SNOW');
    case 'Neige fondue':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_MELTED_SNOW');
    case 'Neige sévère':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_HEAVY_SNOW');
    case 'Nuageux':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_CLOUDY');
    case 'Orage':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_THUNDERSTORM');
    case 'Orage avec pluie':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_THUNDERSTORM_RAIN');
    case 'Pluie':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_RAIN');
    case 'Quelques averses':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_FEW_SHOWERS');
    case 'Quelques nuages':
      return i18next.t('FORECAST.TURNOVER.WEATHER_TYPE_FEW_CLOUDS');
    default:
      return weatherType;
  }
};

export default {
  sortEvents,
  getTranslatedWeatherType,
};
